import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getBuild, getBuildAgent} from '../../../selectors'
import {resolveWebEntityLink} from '../../../utils/entityLinks'

import AgentInfo from './AgentInfo'
import type {OwnProps, StateProps} from './AgentInfo.types'

const PROJECT_POOL_ID = -2

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const build = getBuild(state, buildId)
  const agent = getBuildAgent(state, buildId)
  const canViewAgentDetails = resolveWebEntityLink(agent) != null // There is no link if there is no permission (VIEW_AGENT_DETAILS) or the agent is not authorized
  return {
    withAgent: agent != null,
    withPool: agent?.pool != null && agent.pool.id !== PROJECT_POOL_ID && canViewAgentDetails,
    detachedFromAgent: build?.detachedFromAgent ?? false,
    finishOnAgentDate: build?.finishOnAgentDate,
    isQueued: build?.state === 'queued',
  }
}

export default connect(mapStateToProps)(AgentInfo)
